import { Skeleton } from 'antd'
import { rest } from 'lodash'
import { Suspense, useEffect, useState } from 'react'
import { Switch, Route } from 'react-router-dom'
import { FundOutlined } from '@ant-design/icons'

import { DATA_CENTER, MANAGE_CENTER, sidebarColor, SUBWAY_CENTER } from '@/utils/consts'
import { RootState } from '@/redux/store'
import { useAppSelector } from '@/utils/hooks'
import { isInvalidData, reportEventAegis } from '@/utils/util'

import Header from '@/app/Header'
import SideMenuAside from '@/components/layout/SideMenuAside'

import './SideMenuLayout.less'

interface IPropsSideMenuLayout {
  routes: Routes
}

const setRouterSorted = (routers: Routes, apiUserResources: UserResources): any[] => {
  try {
    routers.forEach(router => {
      const resource = apiUserResources.find(apiResource => {
        return apiResource.id === router.resource?.id
      })
      if (resource && !isInvalidData(resource?.sorted)) {
        router.sorted = resource?.sorted
        router.name = resource?.resourceName
      }
      if (router.routes) {
        router.routes = setRouterSorted(router.routes, apiUserResources)
      }
    })
    return routers
      .filter((router: any) => !isInvalidData(router.sorted))
      .sort((pre: any, next: any) => {
        if (!isInvalidData(pre.sorted) && !isInvalidData(next.sorted)) {
          return pre.sorted - next.sorted
        }
        return 0
      })
  } catch (error: any) {
    console.log(error)
    reportEventAegis({
      name: '设置侧边栏菜单失败',
      ext1: error.message,
    })
    return routers
  }
}

const SideMenuLayout: React.FC<IPropsSideMenuLayout> = ({ routes }) => {
  const { uiConfig, userResources, fullScreen } = useAppSelector((state: RootState) => state.app)

  const [menuList, setMenuList] = useState<Routes>([])

  const getMenuItems = (routes: Routes) => {
    const menuItem: Routes = []

    routes.forEach(item => {
      if (userResources.find(s => s.id === MANAGE_CENTER) && item.path === '/manageCenter') {
        menuItem.push(...(item.routes as any))
      }
    })
    return menuItem
  }

  const getRouters = () => {
    const menus = getMenuItems(routes)
    const routerSorted = setRouterSorted(menus, userResources)
    if (userResources.find(s => s.id === SUBWAY_CENTER)) {
      const resource = userResources.find(s => s.id === SUBWAY_CENTER)
      routerSorted.unshift({
        name: '地铁中心',
        resource: {
          id: SUBWAY_CENTER,
          sorted: 0,
          resourceName: resource?.resourceName || '地铁中心',
        },
        icon: <FundOutlined />,
        path: '/subwayCenter',
      })
    }
    if (userResources.find(s => s.id === DATA_CENTER)) {
      const resource = userResources.find(s => s.id === DATA_CENTER)
      routerSorted.unshift({
        name: '数据中心',
        resource: {
          id: DATA_CENTER,
          sorted: 0,
          resourceName: resource?.resourceName || '数据中心',
        },
        icon: <FundOutlined />,
        path: '/dataCenter',
      })
    }
    setMenuList(routerSorted)
  }

  useEffect(() => {
    getRouters()
  }, [routes])

  return (
    <div className="layout" style={{ alignItems: 'flex-start', flexDirection: 'row' }}>
      {!fullScreen && (
        <section
          className="left-layout-menu-main"
          id="left-layout-menu-main"
          style={{
            backgroundColor: sidebarColor[uiConfig.sidebarColor as any],
          }}
        >
          <SideMenuAside routes={menuList} />
        </section>
      )}
      <section style={{ flex: 1, height: '100%', overflow: 'hidden' }}>
        <Header></Header>
        <Suspense fallback={<Skeleton active></Skeleton>}>
          <div style={{ overflow: 'auto', height: '100%' }}>
            <Switch>
              {routes.map(route => (
                <Route
                  key={route.path}
                  path={route.path}
                  render={props => (
                    <route.component {...props} {...rest} route={route} routes={route.routes} />
                  )}
                />
              ))}
            </Switch>
          </div>
        </Suspense>
      </section>
    </div>
  )
}

export default SideMenuLayout
